'use client';

import { ELocalStorageKeys } from '@/lib/storage/enums';
import type {
    ConsentStorageAdapter,
} from '@web-store-platforms/components/cookie-consent/types';
import {
    createCookieConsentStorageAdapter,
    resolveConsentCookieDomain,
} from '@web-store-platforms/components/cookie-consent/storage';

const resolveDomain = (): string | undefined => {
    const configured = process.env.NEXT_PUBLIC_CONSENT_COOKIE_DOMAIN;
    if (configured) return configured;
    if (typeof window === 'undefined') return undefined;
    return resolveConsentCookieDomain(window.location.hostname);
};

export const cookieConsentStorageAdapter: ConsentStorageAdapter = createCookieConsentStorageAdapter({
    cookieName: ELocalStorageKeys.ANALYTICS_CONSENT,
    domain: resolveDomain(),
    legacyLocalStorageKey: ELocalStorageKeys.ANALYTICS_CONSENT,
});
